import { useLocation, useNavigate } from "react-router";
import { YellowButton } from "../../UI/Button/button";
import classes from "./ClientMatches.module.css";
import {
  cancelMatchTalent,
  completeJob,
  getAllClientJobs,
  matchedJobApplicants,
} from "../../../services/clientCalls";
import { errorHandler, toastSuccess } from "../../../utils";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import img1 from "../../../assets/illustrations/cancel-match.png";
import img2 from "../../../assets/illustrations/approving-stan-blue.png";
import logo from "../../../assets/images/awasource/logo.png";
import { AddIcon, EmailIcon, LocationIcon, PhoneIcon } from "../../../constants/svg";
import PopupModal from "../../CancelMatch/Popup/popup";
import CancelMatchModal from "../../CancelMatch/cancelMatchModal/cancelMatchModal";
import HireLeftModal from "../../CancelMatch/hireLeftModal/hireLeftModal";
import { Link } from "react-router-dom";
import FullScreenLoader from "../../Loaders/FullScreen/loader";
import Back from "../../UI/Back/back";
import MaleAvatar from "../../../assets/svgs/maleAvatar.svg";
import FemaleAvatar from "../../../assets/svgs/femaleAvatar.svg";
import { IconCheckbox, IconMapPin, IconStar, IconStarFilled, IconClipboardCheck, IconEye } from '@tabler/icons-react';
import styles from '../../../pages/ClientDashboard/Feed/Feed.module.css';
import { currencyFormat, initialsFor, modeIconFor, themeFor } from "../../../utils/functions";
import CustomModal from "../../Modal/CustomModal";
import MatchDetailModal from "./MatchDetailModal";
import { EmptyState } from "../../../pages/ClientDashboard/Jobs/jobs";

const ClientMatches = ({ setMatchCancelled, showCancelMatchModal, setCancelShowModal, setIsCancelMatchBtn, }) => {
  let navigate = useNavigate();
  const [applicantsArr, setApplicantsArr] = useState([]);
  const [jobsArr, setJobsArr] = useState([]);
  const [loadingJobs, setLoadingJobs] = useState(false);
  const [jobsData, setJobsData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(null);
  const [matchedTalent, setMatchedTalent] = useState(false);
  const [matchedTalentInfo, setMatchedTalentInfo] = useState({});
  const [applicationId, setApplicationId] = useState(null);
  const [jobInfo, setJobInfo] = useState(null);
  const [matchTimeStampInfo, setMatchTimeInfo] = useState(null);
  const [load, setLoad] = useState(false);
  const [loadingApplicants, setLoadingApplicants] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showHireLeftModal, setShowHireLeftModal] = useState(false);
  const [hireLeftResult, setHireLeftResult] = useState(null);
  const { state } = useLocation();
  // The server accepts a cancel for 48 hours, and that cancel makes the next
  // match free. Hire left (half price) only starts once this window closes.
  const cancelWindowMs = 48 * 60 * 60 * 1000;

  const fetchJobApplicants = async (page) => {
    setLoadingApplicants(true);
    try {
      const res = await matchedJobApplicants(page);
      if (page !== res?.data?.data?.counts) {
        setJobsData(res.data.data);
        setTotalItems(res.data.data.totalItems);
      }
      if (res?.data.data.records) {
        setApplicantsArr(res.data.data.records);
      }
      setLoadingApplicants(false);
    } catch (error) {
      setLoadingApplicants(false);
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
          "Network error: Something went wrong, Please check your internet connection and try again.",
          "Error"
        );
    }
  };

  const fetchJobAllJobs = async () => {
    setLoadingJobs(true);
    try {
      const res = await getAllClientJobs();
      if (res?.data.data.records) {
        setJobsArr(res.data.data.records);
      }
      setLoadingJobs(false);
    } catch (error) {
      setLoadingJobs(false);
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
          "Network error: Something went wrong, Please check your internet connection and try again.",
          "Error"
        );
    }
  };

  const handleCancelMatch = async () => {
    try {
      setLoad(true);
      const res = await completeJob();
      if (res.data.success) toastSuccess(`Match Successful`);
      setLoad(false);
    } catch (error) {
      setLoad(false);
      error.response.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
          "Network error: Something went wrong, Please check your internet connection and try again.",
          "Error"
        );
    }
  };

  useEffect(() => {
    fetchJobApplicants();
    fetchJobAllJobs();
  }, []);

  useEffect(() => {
    if (showModal) {
      setTimeout(() => {
        setShowModal(false);
        setMatchedTalent(false)
      }, 3000);
      // navigate("/talent");
      // window.location.reload();
    }
  }, [showModal]);

  useEffect(() => {
    if (Date.now() - matchTimeStampInfo <= cancelWindowMs) {
      setIsCancelMatchBtn(true)
    }
  }, [matchTimeStampInfo]);

  useEffect(() => {
    if (state && state?.applicant && state?.job) {
      setMatchedTalentInfo(state);
      setJobInfo(state?.job);
      setMatchedTalent(true);
    }
  }, [state]);



  return (
    <>
      {(loadingApplicants || loadingJobs) && <FullScreenLoader />}
      {matchedTalent ? (
        <MatchDetailModal
          handleCancelMatch={handleCancelMatch}
          setShowModal={setShowModal}
          showModal={showModal}
          talent={matchedTalentInfo}
          job={jobInfo}
          matchTimeStamp={matchTimeStampInfo}
          cancelWindowMs={cancelWindowMs}
          setCancelShowModal={setCancelShowModal}
          setMatchedTalent={setMatchedTalent} // ✅ Added for Back button
          setIsCancelMatchBtn={setIsCancelMatchBtn}
          setMatchTimeInfo={setMatchTimeInfo}
          onReportHireLeft={() => setShowHireLeftModal(true)}
        />
      ) : (
        <>
          {applicantsArr?.length > 0 && (
            <div className={classes.grid}>
              {applicantsArr
                ?.filter(
                  (item) =>
                    item?.applicationStatus?.toLowerCase() !== "pending_removal"
                )
                ?.map((item, i) => (
                <TalentCard
                  key={`matches-${i}`}
                  navigate={navigate}
                  setMatchedTalent={setMatchedTalent}
                  setMatchedTalentInfo={setMatchedTalentInfo}
                  setJobInfo={setJobInfo}
                  matchTimeStamp={item?.matchTimeStamp}
                  setMatchTimeInfo={setMatchTimeInfo}
                  setApplicationId={setApplicationId}
                  {...item}
                />
              ))}
            </div>
          )}
          {jobsArr?.length === 0 && !loadingApplicants && !loadingJobs && (
            <EmptyState
              title="You have not created a Job or Gig"
              message="Start by creating a new job"
            />
          )}
          {jobsArr?.length > 0 && applicantsArr?.length === 0 && !loadingApplicants && !loadingJobs && (
            <div className={classes.noMatches}>
              <img src={img1} alt="No Matches" />
              <p>No matches yet</p>
            </div>
          )}
        </>
      )}

      {showCancelMatchModal && (
        <CancelMatchModal
          setShowModal={setCancelShowModal}
          jobId={applicationId}
          setSuccessModal={setShowModal}
          setMatchCancelled={setMatchCancelled}
          fetchJobApplicants={fetchJobApplicants}
          setMatchTimeInfo={setMatchTimeInfo}
          setIsCancelMatchBtn={setIsCancelMatchBtn}
          applicantID={matchedTalentInfo?._id}
        />
      )}

      {showHireLeftModal && (
        <HireLeftModal
          applicantId={applicationId}
          talentName={[matchedTalentInfo?.firstName, matchedTalentInfo?.lastName].filter(Boolean).join(" ")}
          jobTitle={jobInfo?.title}
          setShowModal={setShowHireLeftModal}
          onReported={(data) => {
            setHireLeftResult(data);
            setMatchedTalent(false);
            setMatchTimeInfo(null);
            setIsCancelMatchBtn(false);
            fetchJobApplicants();
          }}
        />
      )}

      {hireLeftResult && (
        <CustomModal
          state="success"
          title="Job reopened"
          description={hireLeftResult.message}
          primaryLabel="Find a new match"
          onClose={() => setHireLeftResult(null)}
          onPrimaryAction={() => {
            setHireLeftResult(null);
            navigate("/talent");
          }}
        />
      )}
    </>
  );
};

export default ClientMatches;

const SingleTalent = ({
  _id,
  job,
  talent,
  navigate,
  applicationStatus,
  setMatchedTalent,
  setMatchedTalentInfo,
  setJobInfo,
  matchTimeStamp,
  setMatchTimeInfo,
  setApplicationId
}) => (
  <div className={`flex center ${classes.single_talent}`}>
    <p>
      {job?.title} in {talent?.currentLocation} <br />
      applied for your job
    </p>
    <hr />
    <div className={`center-flex ${classes.profile}`}>
      <img src={logo} />
    </div>
    <hr />
    <YellowButton
      extra={classes.viewBtn}
      onClick={() => {
        if (applicationStatus === "Applied") {
          navigate(`/talent-profile/review/${_id}`, {
            state: { talent, job },
          });
        } else {
          setMatchedTalent(true);
          setMatchedTalentInfo(talent);
          setJobInfo(job);
          setMatchTimeInfo(matchTimeStamp);
          setApplicationId(_id);
        }
      }}
      disabled={applicationStatus === "Pending_Removal"}
    >
      View
    </YellowButton>
  </div>
);



const TalentCard = ({
  onToggleStar,
  onView,
  _id,
  job,
  talent,
  navigate,
  applicationStatus,
  setMatchedTalent,
  setMatchedTalentInfo,
  setJobInfo,
  matchTimeStamp,
  setMatchTimeInfo,
  setApplicationId,
}) => {
  const talentName = [talent?.firstName, talent?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  const theme = themeFor(talentName || talent?.email || job?.title);
  const appliedText = talentName
    ? `${talentName} · Matched to ${job?.title || "your job"}`
    : `${job?.title} · Applied for your job · ${talent?.currentLocation}`;

  return (
    <div className={styles.card}>
      {appliedText && (
        <div className={styles.cardApplied}>
          <IconCheckbox size={14} />
          <span>{appliedText}</span>
        </div>
      )}

      <div className={styles.cardTop}>
        <div
          className={`${styles.mono} ${styles.cardAvatar}`}
          style={{ background: theme.bg, color: theme.fg }}
        >
          {initialsFor(talentName || talent?.email)}
        </div>
        <div className={styles.cardId}>
          <div className={styles.cardRole}>
            <span className={styles.cardRoleText}>{talentName || job?.title}</span>
            {talent?.psychometric && (
              <span className={styles.psychBadge}>
                <IconClipboardCheck size={11} /> Psychometric
              </span>
            )}
          </div>
          <div className={styles.cardLoc}>
            <IconMapPin size={13} /> <span>{talent?.currentLocation}</span>
          </div>
        </div>
        {/* <button
          className={`${styles.cardStar} ${talent.shortlisted ? styles.cardStarActive : ''}`}
          onClick={(e) => { e.stopPropagation(); onToggleStar(talent.id); }}
          aria-label={talent.shortlisted ? 'Remove from shortlist' : 'Add to shortlist'}
          title={talent.shortlisted ? 'Remove from shortlist' : 'Add to shortlist'}
        >
          {talent.shortlisted ? <IconStarFilled size={18} /> : <IconStar size={18} />}
        </button> */}
      </div>

      <div className={styles.cardSection}>
        <div className={styles.cardSectionLabel}>Work preferences</div>
        <div className={styles.cardModes}>
          {talent?.workMode?.map((m) => {
            const ModeIcon = modeIconFor(m);
            return (
              <span key={m} className={styles.modeChip}>
                <ModeIcon size={12} /> {m}
              </span>
            );
          })}
        </div>
      </div>

      <div className={styles.cardSection}>
        <div className={styles.cardSectionLabel}>Top skills</div>
        <div className={styles.cardTags}>
          {talent?.primarySkills?.map((s) => (
            <span key={s} className={styles.skillTag}>
              {s}
            </span>
          ))}
        </div>
      </div>

      <div className={styles.cardFooter}>
        <div>
          <div className={styles.cardPayLabel}>Expected pay</div>
          <div className={styles.cardPay}>
            &#8358;
            {currencyFormat(
              Number(talent?.desiredCompensation?.lowestAmount ?? 0),
            )}{" "}
            <span>-</span> &#8358;
            {currencyFormat(
              Number(talent?.desiredCompensation?.highestAmount ?? 0),
            )}
          </div>
        </div>
        <button
          className={styles.cardView}
          onClick={(e) => {
            e.stopPropagation();

            if (applicationStatus === "Applied") {
              navigate(`/talent-profile/review/${_id}`, {
                state: { talent, job },
              });
            } else {
              setMatchedTalent(true);
              setMatchedTalentInfo(talent);
              setJobInfo(job);
              setMatchTimeInfo(matchTimeStamp);
              setApplicationId(_id);
            }
          }}
          disabled={applicationStatus === "Pending_Removal"}
        >
          <IconEye size={15} /> View profile
        </button>
      </div>
    </div>
  );
};
